<template>
  <div id="app">
    <router-view/>
    <div v-if="loading" class="loader">
      <img  src="/static/images/svgs/loader.svg" alt="Loading...">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed:{
    ...mapGetters([
      "sessionId",
      "user",
      "loading"
    ])
  },
  mounted() {

    if(this.sessionId){
      this.$router.push({ name:this.$route.name })
    }
    else{
      this.$router.push({ name:'Login' })
    }
  }
}
</script>

<!-- Importing bootstrap and bootstrap-vue -->
<style src="bootstrap/dist/css/bootstrap.css" ></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css" ></style>
<style src="./assets/scss/custom.scss" lang="scss"></style>
<!-- // <style lang="scss" src="./style.scss" media="screen"> -->

</style>
<!-- Local style for the component -->
<style scoped lang="scss">
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


.loader{
  z-index: 9999999;
  position: fixed;
  height: 100vh;
  width:100vw;
  top:0;
  left:0;
  background: rgba(255,255,255,0.8);
  img{
    position: absolute;
    top:0;
    left: 0;
    right:0;
    bottom:0;
    margin: auto;
    display: block;
    width: 36px;
    height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue